import React from 'react';
import { DevicePhoneMobileIcon } from '@heroicons/react/24/outline';

const PlanningMobileFallback = () => {
  return (
    <div className="block flex h-full w-full items-center justify-center p-4 lg:hidden">
      <div className="mx-auto max-w-md text-center">
        <DevicePhoneMobileIcon className="mx-auto mb-4 h-16 w-16 text-gray-400" />
        <h2 className="mb-2 text-xl font-semibold text-gray-900">Desktop Required</h2>
        <p className="mb-4 text-gray-600">
          The planning interface is optimized for desktop use with drag-and-drop functionality.
          Please use a desktop or laptop computer to access this feature.
        </p>
        <p className="text-sm text-gray-500">
          Mobile planning features will be available in a future update.
        </p>
      </div>
    </div>
  );
};

export default PlanningMobileFallback;
